import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { useLayout6Theme } from './theme';
import './styles.css';

interface Layout6RootProps {
  children: ReactNode;
  className?: string;
  withHeader?: boolean;
}

export function Layout6Root({ children, className, withHeader }: Layout6RootProps) {
  const { themeStyle } = useLayout6Theme();

  return (
    <div
      className={cn(
        'layout-6 min-h-screen bg-[var(--wl6-bg)]',
        withHeader && 'layout-6-with-header',
        className
      )}
      style={themeStyle}
    >
      {children}
    </div>
  );
}
